import { useTranslation } from "react-i18next";
import { z } from "zod";
import { DateAdapter } from "@myphx-engineering/date-utils/client";

//#region src/hooks/form-validation/use-dob-zod-schema.ts
const useDobZodSchema = (withMinimumAge = true) => {
	const { t } = useTranslation("pds");
	return z.string().regex(/^\d{2}\/\d{2}\/\d{4}$/, { message: t("common.formErrors.dob.invalid") }).superRefine((val, ctx) => {
		const dayParts = val.split("/");
		const month = Number.parseInt(dayParts[0], 10);
		const day = Number.parseInt(dayParts[1], 10);
		const year = Number.parseInt(dayParts[2], 10);
		if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: t("common.formErrors.dob.required"),
				fatal: true
			});
			return z.NEVER;
		}
	}).superRefine((val, ctx) => {
		const dayParts = val.split("/");
		const month = Number.parseInt(dayParts[0], 10);
		const day = Number.parseInt(dayParts[1], 10);
		const year = Number.parseInt(dayParts[2], 10);
		if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: t("common.formErrors.dob.invalid"),
				fatal: true
			});
			return z.NEVER;
		}
	}).superRefine((val, ctx) => {
		const dayParts = val.split("/");
		const month = Number.parseInt(dayParts[0], 10);
		const day = Number.parseInt(dayParts[1], 10);
		const year = Number.parseInt(dayParts[2], 10);
		if (!DateAdapter.isValidDate(year, month, day)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: t("common.formErrors.dob.invalid"),
				fatal: true
			});
			return z.NEVER;
		}
	}).superRefine((val, ctx) => {
		const dayParts = val.split("/");
		const month = Number.parseInt(dayParts[0], 10);
		const day = Number.parseInt(dayParts[1], 10);
		const year = Number.parseInt(dayParts[2], 10);
		if (DateAdapter.isFutureDate(year, month, day)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: t("common.formErrors.dob.future"),
				fatal: true
			});
			return z.NEVER;
		}
	}).superRefine((val, ctx) => {
		if (!withMinimumAge) return;
		const dayParts = val.split("/");
		const month = Number.parseInt(dayParts[0], 10);
		const day = Number.parseInt(dayParts[1], 10);
		const year = Number.parseInt(dayParts[2], 10);
		if (!DateAdapter.validateAge(year, month, day, 13)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: t("common.formErrors.dob.tooYoung"),
				fatal: true
			});
			return z.NEVER;
		}
	});
};

//#endregion
export { useDobZodSchema };